import React from 'react'
import Slider from 'react-slick'

const images = [
    'https://assets.learntube.ai/files/Global/companies/Frame%20328%20(2).png?updatedAt=1744366964676',
    'https://assets.learntube.ai/files/Global/companies/Frame%20329%20(2).png?updatedAt=1744366972677',
    'https://assets.learntube.ai/files/Global/companies/Frame%2022062%20(1).png?updatedAt=1744366935749',
    'https://assets.learntube.ai/files/Global/companies/Frame%2022063%20(1).png?updatedAt=1744366932912',
    'https://assets.learntube.ai/files/Global/companies/Frame%2022064%20(1).png?updatedAt=1744366930919',
    'https://assets.learntube.ai/files/Global/companies/Frame%2022062%20(2).png?updatedAt=1744366930805',
    'https://assets.learntube.ai/files/Global/companies/Frame%20327%20(2).png?updatedAt=1744366930681',
    'https://assets.learntube.ai/files/Global/companies/Frame%2022065%20(1).png?updatedAt=1744367151638'
]

const CompaniesSection = () => {

    const settings = {
        dots: false,
        slidesToShow: 4,
        rows: 1,
        speed: 6000,
        autoplay: true,
        autoplaySpeed: 3000,
        easing: 'linear',
        cssEase: "linear",
        infinite: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    infinite: true,
                    dots: false,
                    swipeToSlide: true,
                },
            },
    ]}

    return (
        <div className=''>
            <Slider {...settings}>
                {images.map((image, index) => (
                    <div key={index} className='w-full h-full'>
                        <img src={image} className='w-[95%] h-full' alt="" />
                    </div>
                ))}
            </Slider>
        </div>
    )
}

export default CompaniesSection